export default {
  partner: {
    header: {
      title: 'Mehr als eine Buchungsplattform',
      description:
        'Verwalte Dein Unternehmen mit einer All-in-One-Software und steigere Deinen Umsatz.',
      buttonLabel: 'Jetzt loslegen',
    },
  },
}
